"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.complete = exports.setup = void 0;
const core = __importStar(require("@actions/core"));
const exec = __importStar(require("@actions/exec"));
const path = __importStar(require("path"));
const os = __importStar(require("os"));
const caches = __importStar(require("./caches"));
const layout = __importStar(require("./repository-layout"));
const params = __importStar(require("./input-params"));
const dependencyGraph = __importStar(require("./dependency-graph"));
const jobSummary = __importStar(require("./job-summary"));
const build_results_1 = require("./build-results");
const cache_reporting_1 = require("./cache-reporting");
const daemon_controller_1 = require("./daemon-controller");
const GRADLE_SETUP_VAR = 'GRADLE_BUILD_ACTION_SETUP_COMPLETED';
const USER_HOME = 'USER_HOME';
const GRADLE_USER_HOME = 'GRADLE_USER_HOME';
const CACHE_LISTENER = 'CACHE_LISTENER';
function setup() {
    return __awaiter(this, void 0, void 0, function* () {
        const userHome = yield determineUserHome();
        const gradleUserHome = yield determineGradleUserHome();
        if (process.env[GRADLE_SETUP_VAR]) {
            core.info('Gradle setup only performed on first gradle-build-action step in workflow.');
            return;
        }
        core.exportVariable(GRADLE_SETUP_VAR, true);
        core.saveState(GRADLE_SETUP_VAR, true);
        core.saveState(USER_HOME, userHome);
        core.saveState(GRADLE_USER_HOME, gradleUserHome);
        const cacheListener = new cache_reporting_1.CacheListener();
        yield caches.restore(userHome, gradleUserHome, cacheListener);
        core.saveState(CACHE_LISTENER, cacheListener.stringify());
        yield dependencyGraph.setup(params.getDependencyGraphOption());
    });
}
exports.setup = setup;
function complete() {
    return __awaiter(this, void 0, void 0, function* () {
        if (!core.getState(GRADLE_SETUP_VAR)) {
            core.info('Gradle setup post-action only performed for first gradle-build-action step in workflow.');
            return;
        }
        core.info('In post-action step');
        const buildResults = (0, build_results_1.loadBuildResults)();
        const userHome = core.getState(USER_HOME);
        const gradleUserHome = core.getState(GRADLE_USER_HOME);
        const cacheListener = cache_reporting_1.CacheListener.rehydrate(core.getState(CACHE_LISTENER));
        const daemonController = new daemon_controller_1.DaemonController(buildResults);
        yield caches.save(userHome, gradleUserHome, cacheListener, daemonController);
        yield jobSummary.generateJobSummary(buildResults, cacheListener);
        yield dependencyGraph.complete(params.getDependencyGraphOption());
        core.info('Completed post-action step');
    });
}
exports.complete = complete;
function determineGradleUserHome() {
    return __awaiter(this, void 0, void 0, function* () {
        const customGradleUserHome = process.env['GRADLE_USER_HOME'];
        if (customGradleUserHome) {
            const rootDir = layout.workspaceDirectory();
            return path.resolve(rootDir, customGradleUserHome);
        }
        return path.resolve(yield determineUserHome(), '.gradle');
    });
}
function determineUserHome() {
    return __awaiter(this, void 0, void 0, function* () {
        const output = yield exec.getExecOutput('java', ['-XshowSettings:properties', '-version'], { silent: true });
        const regex = /user\.home = (\S*)/i;
        const found = output.stderr.match(regex);
        if (found == null || found.length <= 1) {
            core.info('Could not determine user.home from java -version output. Using os.homedir().');
            return os.homedir();
        }
        const userHome = found[1];
        core.debug(`Determined user.home from java -version output: '${userHome}'`);
        return userHome;
    });
}
